import { Link } from "react-router-dom";
import { BedDouble, Bath, Users, ArrowRight } from "lucide-react";
import Reveal from "@/components/Reveal";

export const PropertyCard = ({ property, index = 0 }) => {
  const second = property.gallery?.[0] && property.gallery[0] !== property.hero ? property.gallery[0] : null;

  return (
    <Reveal delay={index * 110}>
      <Link
        to={`/stay/${property.slug}`}
        className="group block bg-[#FCFAF6] border border-[#0F2A52]/10 hover:border-[#B08A3E]/60 hover:-translate-y-1 hover:shadow-[0_40px_80px_-50px_rgba(15,42,82,0.6)] transition-all duration-500"
        data-testid={`property-card-${property.slug}`}
      >
        <div className="relative overflow-hidden aspect-[4/3] md:aspect-[3/2]">
          <img
            src={property.hero}
            alt={property.heroAlt || `${property.name} holiday accommodation, ${property.location}`}
            loading="lazy"
            className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.06]"
          />
          {second && (
            <img
              src={second}
              alt=""
              loading="lazy"
              aria-hidden="true"
              className="absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-700"
            />
          )}
          <div className="absolute inset-0 bg-gradient-to-t from-[#0A1D3A]/80 via-[#0A1D3A]/10 to-transparent" />
          {property.badge && (
            <span
              className="absolute top-5 left-5 bg-[#E4C67A] text-[#0F2A52] text-[11px] uppercase tracking-[0.2em] px-4 py-2"
              data-testid={`property-badge-${property.slug}`}
            >
              {property.badge}
            </span>
          )}
          <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
            <p className="text-[11px] uppercase tracking-[0.28em] text-[#E4C67A]">{property.location}</p>
            <h3 className="font-display text-3xl md:text-4xl text-[#FCFAF6] mt-2">{property.name}</h3>
          </div>
        </div>

        <div className="p-6 md:p-8">
          {property.tagline && (
            <p className="text-sm text-[#B08A3E] italic leading-relaxed">{property.tagline}</p>
          )}
          <p className="text-sm text-[#4A4A4A] leading-relaxed mt-3">{property.short}</p>
          <div className="flex flex-wrap items-center gap-5 mt-6 text-xs text-[#4A4A4A]">
            <span className="flex items-center gap-2">
              <BedDouble size={15} className="text-[#B08A3E]" /> {property.bedrooms}{" "}
              {property.bedrooms === 1 ? "bed" : "beds"}
            </span>
            <span className="flex items-center gap-2">
              <Bath size={15} className="text-[#B08A3E]" /> {property.bathrooms}{" "}
              {property.bathrooms === 1 ? "bath" : "baths"}
            </span>
            <span className="flex items-center gap-2">
              <Users size={15} className="text-[#B08A3E]" /> sleeps {property.sleeps}
            </span>
          </div>
          <div className="flex items-end justify-between gap-4 mt-8 pt-6 border-t border-[#B08A3E]/30">
            <span className="text-sm text-[#4A4A4A]" data-testid={`property-rate-${property.slug}`}>
              Enquire for rates &amp; availability
            </span>
            <span className="flex items-center gap-2 text-sm text-[#B08A3E] group-hover:gap-4 transition-all duration-300">
              View <ArrowRight size={15} />
            </span>
          </div>
        </div>
      </Link>
    </Reveal>
  );
};

export default PropertyCard;
